import React, { Component } from 'react'

// ui
import { FaEdit, FaTrashAlt } from 'react-icons/fa'

// button
import Button from '../../components/uielements/button'
import { Menu, Dropdown, Col, Tag, Row, Tooltip, Checkbox } from 'antd'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/object/actions'
import scrumBoardActions from '../../redux/scrumBoard/actions'
import objectDefault from '../../resource/image/objectDefault.png'
class ObjectComponent extends Component {
    state = {
        ischeck: this.props.isChoose ? this.props.isChoose : false,
    }
    _handleDetailClick = () => {
        const { object } = this.props
        this.props.updateCurrentObject(object)
        this.props.showModalCurrentObjectInfo()
    }

    _handleDeleteClick = () => {
        const { object } = this.props
        this.props.updateCurrentObject(object)
        this.props.showModalConfirmDeleteObject()
    }

    _handleUpdateCurrentObject = () => {
        const { ischeck } = this.state
        const { updateListObject, object } = this.props
        if (ischeck) {
            updateListObject(object, false)
            this.setState({ ischeck: false })
        } else {
            updateListObject(object, true)
            this.setState({ ischeck: true })
        }
    }

    render() {
        const { object, isShowInTask } = this.props
        const { hashtag } = object
        const { ischeck } = this.state
        console.log('isShowInTask', object)

        return (
            <Col className="ObjectContainer" md={6} lg={6} xs={8} xxl={4}>
                <div className="ObjectComponent">
                    <div
                        className="AvatarImage"
                        onClick={() => this._handleUpdateCurrentObject()}
                    >
                        <img
                            src={
                                object.avatar !== ''
                                    ? object.avatar
                                    : objectDefault
                            }
                            style={{ objectFit: 'contain' }}
                            alt="avatar"
                        />
                        {isShowInTask && (
                            <Checkbox
                                className="Checkbox"
                                checked={ischeck}
                            ></Checkbox>
                        )}
                    </div>
                    <div className="ObjectBody">
                        <Row className="ListTag">
                            <div className="ObjectName">{object.name}</div>
                            {hashtag.map((tag, index) => {
                                return (
                                    <Tag
                                        color="blue"
                                        key={index}
                                        className="Tag"
                                    >
                                        {tag}
                                    </Tag>
                                )
                            })}
                        </Row>
                    </div>
                    <Row className="ObjectAction">
                        <Col md={12}>
                            <Button
                                style={{ backgroundColor: '#b3e6ff' }}
                                onClick={() => this._handleDetailClick()}
                            >
                                <FaEdit />
                                Chi tiết
                            </Button>
                        </Col>
                        <Col md={12}>
                            <Button
                                style={{ backgroundColor: '#ff9999' }}
                                onClick={() => this._handleDeleteClick()}
                            >
                                <FaTrashAlt />
                                Xoá
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        showModalConfirmDeleteObject: () => {
            dispatch(objectActions.action.showModalConfirmDeleteObject())
        },
        showModalCurrentObjectInfo: () => {
            dispatch(objectActions.action.showModalCurrentObjectInfo())
        },
        updateCurrentObject: object => {
            dispatch(objectActions.action.updateCurrentObject(object))
        },
        updateListObject: (data, ispush) => {
            dispatch(scrumBoardActions.updateListObject(data, ispush))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ObjectComponent)
